export const iconFontAwesomeFilesFile = (
	<i className="fa-solid fa-file"></i>
);
